<template>
  <div class="workBench-itemTab"
        v-loading = "itemLoading" v-if="tabShowDataAll">
   <!-- 项目tab -->
   <div @click="toPath(tabData[0].projectURL)" class="itemTab-more">{{"更多>>"}}</div>
    <el-tabs
     v-model="activeName" @tab-click="tabClick">
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
        v-if="type=='1'&&tabShowData['1']" label="我发起的申请" name="1">

        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData)" @click="toPath(item.itemURL)">
            <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip></p>
            <p class="tab-item-p2 mb0"><span class="mr15">{{item.itemCode}}</span><tag class="fr" :statusName="item.statusName" :type="`${item.sign}fq`" :status="item.statusCode"></tag></p>
            <!-- <p class="tab-item-p3 mb15"><span class="mr5">{{item.departmentName}}</span>{{item.applyUserName}}</p> -->
          </div>
        </div>
        <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
        <el-pagination
          class="itemTab-page"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          prev-text="上一页"
          next-text="下一页"
          :page-size="4"
          layout="prev, next"
          :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
        v-if="type=='1'&&tabShowData['2']" label="待处理的申请" name="2">
          <div class="tab-list">
            <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData) " @click="toPath(item.itemURL)">
              <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip></p>
              <p class="tab-item-p2 mb15" v-if="item.sign=='xq'">
                <span class="ellipsis"><span class="">{{item.erpMaterialCode}}{{item.erpMaterialCode?'/':''}}</span><span>{{item.materialName}}{{item.materialName?'/':''}}</span><span class="mr15">{{item.specificationType}}</span></span>
                <!-- <tag class="fr" :statusName="item.statusName" :type="`${item.sign}cl`" :status="item.statusCode"></tag> -->
              </p>
              <p class="tab-item-p2 mb15" v-else>
                <span class="mr15">{{item.itemCode}}</span>
                <tag v-if="item.sign=='cz'" class="fr" :statusName="item.statusName" :type="`${item.sign}cl`" :status="item.statusCode"></tag>

                <!-- <tag type="2" :status="item.statusCode"></tag> -->
              </p>
              <p class="tab-item-p3 mb0"><span class="mr5">{{item.departmentName}}</span>{{item.applyUserName}}</p>
            </div>
          </div>
          <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
          <el-pagination
            class="itemTab-page"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            prev-text="上一页"
            next-text="下一页"
            :page-size="4"
            layout="prev, next"
            :total="currentTotal">
          </el-pagination>
        </el-tab-pane>
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
        v-if="(type=='2'||type=='1')&&tabShowData['3']" label="进行中的项目" name="3">
        <el-button-group class="tab-pane-project-checkout" style="margin-bottom: 10px;" v-if="type == 1">
          <el-button v-for="typeIt in projectTypeList"
                     @click="changeProjectType(typeIt.val)"
                     :key="typeIt.val"
                     :class="typeIt.val == projectType ? 'active': ''">{{ typeIt.label }}
          </el-button>
        </el-button-group>
        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData)" @click="toPath(item.itemURL)">
            <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip><classTag :projectType="projectType" class="fr" :status="item.typeCode"></classTag><tag class="fr" v-if="type=='2'" :type="'4'" :status="item.statusCode"></tag></p>
            <p v-if="type=='1'" class="tab-item-p2 mb0"><span class="mr15">{{item.itemCode}}</span><tag class="fr" :statusName="item.statusName" :type="'1'" :status="item.statusCode"></tag></p>
            <p v-if="type=='2'" class="tab-item-p2 mb15"><span class="mr15">{{item.purchaseName}}</span><tag class="fr" :statusName="item.supplierStatus" :type="'1'" :status="item.supplierStatusCode"></tag></p>
            <p v-if="type=='2'" class="tab-item-p2 mb0">
              <img v-if="item.endTime" class="mr5" src="../../../assets/images/icon_time.svg" alt="">
              <span class="mr5" v-if="item.endTime">截止时间：{{item.endTime}}</span>

              <span  class="red-col fr">{{item.statusName}}</span>
            </p>
            <!-- <p class="tab-item-p3 mb15"><span class="mr5">{{item.departmentName}}</span>{{item.applyUserName}}</p> -->
          </div>
        </div>
        <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
        <el-pagination
          class="itemTab-page"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          prev-text="上一页"
          next-text="下一页"
          :page-size="4"
          layout="prev, next"
          :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
        v-if="type=='1'&&tabShowData['4']" label="我签定的合同" name="4">
          <div class="tab-list">
            <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData)" @click="toPath(item.itemURL)">
              <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip></p>
              <!-- {{`${item.sign}cj`}} -->
              <p class="tab-item-p2 mb15"><span class="mr15">{{item.purchaseName}}</span><tag class="fr" :statusName="item.statusName" :type="`${item.sign}cj`" :status="item.statusCode"></tag></p>
              <p class="tab-item-p3 mb0"><span class="mr5">{{item.departmentName}}</span>{{item.applyUserName}}</p>
            </div>
          </div>
          <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
          <el-pagination
            class="itemTab-page"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            prev-text="上一页"
            next-text="下一页"
            :page-size="4"
            layout="prev, next"
            :total="currentTotal">
          </el-pagination>
        </el-tab-pane>
      <el-tab-pane

       element-loading-text = "加载中..."
       element-loading-spinner = "el-icon-loading"
      v-if="(type=='2'||type=='1')&&tabShowData['5']" :label="type=='1'?'进行中的订单':'待确认的订单'" name="5">
        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData)" @click="toPath(item.itemURL)">
            <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip></p>
            <p class="tab-item-p2" :class="type=='2'?'mb15':'mb0'"><span class="mr15">{{item.itemCode}}</span><tag class="fr" :statusName="item.statusName"  type="5" :status="item.statusCode"></tag></p>
            <p v-if="type=='2'" class="tab-item-p2 mb0">
            <img class="mr5" src="../../../assets/images/money_icon.svg" alt="">
            <span class="mr5">订单金额：{{item.amountOfMoney?Number(item.amountOfMoney).toFixed(2):item.amountOfMoney}}</span>

            </p>
          </div>
        </div>
        <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
        <el-pagination
          class="itemTab-page"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          prev-text="上一页"
          next-text="下一页"
          :page-size="4"
          layout="prev, next"
          :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane

       element-loading-text = "加载中..."
       element-loading-spinner = "el-icon-loading"
       v-if="type=='2'&&tabShowData['6']" label="待处理的发货" name="6">
          <div class="tab-list">
            <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData)" @click="toPath(item.itemURL)">
              <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip></p>
              <p class="tab-item-p2" :class="type=='2'?'mb15':'mb0'"><span class="mr15  item-p1-ellipsis">{{item.itemCode}}</span><tag :statusName="item.statusName" class="fr" type="5" :status="item.statusCode"></tag></p>
              <!-- <p class="tab-item-p3 mb15"><span class="mr5">{{item.departmentName}}</span>{{item.applyUserName}}</p> -->
              <p v-if="type=='2'" class="tab-item-p2 mb0">
              <img class="mr5" src="../../../assets/images/money_icon.svg" alt="">
              <span class="mr5">订单金额：{{item.amountOfMoney?Number(item.amountOfMoney).toFixed(2):item.amountOfMoney}}</span>

              </p>
            </div>
          </div>
          <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
          <el-pagination
            class="itemTab-page"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            prev-text="上一页"
            next-text="下一页"
            :page-size="4"
            layout="prev, next"
            :total="currentTotal">
          </el-pagination>
       </el-tab-pane>
      <el-tab-pane
              element-loading-text = "加载中..."
              element-loading-spinner = "el-icon-loading"
              label="我审批的项目" name="7" v-if="type == 1 && isShowMeCheckProjectItems === '0'">
        <el-button-group class="tab-pane-project-checkout" style="margin-bottom: 10px;">
          <el-button v-for="typeIt in projectTypeList"
                     @click="changeProjectType1(typeIt.val)"
                     :key="typeIt.val"
                     :class="typeIt.val == projectType1 ? 'active': ''">{{ typeIt.label }}
          </el-button>
        </el-button-group>
        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in (tabData[0]&&tabData[0].statusCode=='404'?[]:tabData)" @click="toPath(item.itemURL)">
            <p class="tab-item-p1 mb15"><el-tooltip :content="`${item.itemName}`" placement="top"><span class="mr15 fw item-p1-ellipsis">{{item.itemName}}</span></el-tooltip><classTag :projectType="projectType1" class="fr" :status="item.typeCode"></classTag><tag class="fr" v-if="type=='2'" :type="'4'" :status="item.statusCode"></tag></p>
            <p class="tab-item-p2" :class="type=='2'?'mb15':'mb0'"><span class="mr15  item-p7-ellipsis">{{item.itemCode}}</span><tag :statusName="item.statusName" class="fr" type="5" :status="item.statusCode"></tag></p>
            <!-- <p class="tab-item-p3 mb15"><span class="mr5">{{item.departmentName}}</span>{{item.applyUserName}}</p> -->
            <p v-if="type=='2'" class="tab-item-p2 mb0">
              <img class="mr5" src="../../../assets/images/money_icon.svg" alt="">
              <span class="mr5">订单金额：{{item.amountOfMoney?Number(item.amountOfMoney).toFixed(2):item.amountOfMoney}}</span>

            </p>
          </div>
        </div>
        <emptyTab v-if="(tabData&&tabData.length==0)||(tabData[0]&&tabData[0].statusCode=='404')"></emptyTab>
        <el-pagination
                class="itemTab-page"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                prev-text="上一页"
                next-text="下一页"
                :page-size="4"
                layout="prev, next"
                :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tag from './tag.vue'
import classTag from './classTag.vue'
import emptyTab from './emptyTab.vue'
export default {
  // type 1为采购商 2为供应商，
  props: ['type'],
  components: {
    'tag' : tag,
    'classTag' : classTag,
    'emptyTab' : emptyTab
  },
  data () {
    return {
      itemLoading: false,
      activeName: '1',
      currentPage: 1,
      currentTotal: 8,
      tabData: [],
      tabShowData:{
        '1':false,
        '2':false,
        '3':false,
        '4':false,
        '5':false,
        '6':false,
        '7':false
      },
      projectType: 10,  // 招标项目 10  询比价 20
      projectType1: 10,  // 招标项目 10  询比价 20
      projectTypeList: [{label: '招投标项目', val: 10}, {label: '询比价项目', val: 20}],
      isShowMeCheckProjectItems: '0'
    }
  },
  computed:{
    // 判断是否都无权限
    tabShowDataAll(){
      let isShow=false
      Object.keys(this.tabShowData).map(item=>{
        if(this.tabShowData[item]){
          isShow=true
        }
      })
      return isShow
    }
  },
  mounted () {
    this.initItem()
  },
  methods: {

    // 切换 招标项目 10  询比价 20
    changeProjectType (val) {
      this.projectType = val
      this.tabClick(this.activeName)
    },
    // 切换 招标项目 10  询比价 20
    changeProjectType1 (val) {
      this.projectType1 = val
      this.tabClick(this.activeName)
    },
    initItem(){

      // type 1为采购商 2为供应商，
      if(this.type==1){
        this.loadPurcahseItems()
      }else{
        this.loadSupplierItems()
      }
    },
    toPath (url) {
      window.open(url, '_blank')
    },
    setAllList(data,cb){
      // data=res.data
      this.itemLoading = false
      this.tabData = data||[]
      // console.info(data)
      if(data&&data.length==0){
      //   // this.tabData = data
        cb && cb()
        this.currentTotal = (data[0]&&Number(data[0].totalRecords))||0
      }else{

        this.tabData = data||[]
        this.currentTotal = (data[0]&&Number(data[0].totalRecords))||0
      }
      // if (data.length < 4) {
      //   this.tabData = data
      //   this.currentTotal = (this.currentPage - 1) * 4 + data.length
      //   // console.info(this.currentTotal,this.currentPage)
      // } else if(data&&data.length==0){
      //   // this.tabData = data
      //   cb && cb()
      //   this.currentTotal = (this.currentPage - 1) * 4 + (data.length||0)
      //   // console.info(this.currentTotal,this.currentPage)
      // }else {
      //   this.tabData = data
      //   this.currentTotal = this.currentPage * 4 + 1
      // }
    },
    setList(data,cb){
      // data=res.data
      this.itemLoading = false
      console.info(data)
      if (data.code == 0) {

        if(data.rows&&data.rows.length==0){
        //   // this.tabData = data
          cb && cb()
          this.currentTotal = data.rows&&Number(data.rows[0].totalRecords)
        }else{

          this.tabData = data.rows
          this.currentTotal = data&&Number(data.rows[0].totalRecords)
        }
        // if (data.rows.length < 4) {
        //   this.tabData = data.rows
        //   this.currentTotal = (this.currentPage - 1) * 4 + data.rows.length
        //   // console.info(this.currentTotal,this.currentPage)
        // } else if(data.rows&&data.rows.length==0){
        //   // this.tabData = data.rows
        //   cb && cb()
        //   this.currentTotal = (this.currentPage - 1) * 4 + (data.rows.length||0)
        //   // console.info(this.currentTotal,this.currentPage)
        // }else {
        //   this.tabData = data.rows
        //   this.currentTotal = this.currentPage * 4 + 1
        // }
      } else {
        this.$message.error(data.errorMsg);
      }
    },
    // 获取列表
    getList(cb){

      this.itemLoading = true
      // type 1为采购商 2为供应商，
      if(this.type=='1'){
        if (this.activeName =='1') {
          // 我发起的申请
          this.loadApply(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='2') {
          // 待处理的申请
          this.loadHandledApply(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='3') {
          // 进行中的项目
          this.loadDoingProject(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='4') {

          // 我签定的合同
          this.queryContractList(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='5') {
          // 待确认的订单

          this.loadDoingOrder(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='7') {
          // 我发起的审批
          this.loadMeCheckProject(()=>{
            cb&&cb()
          })
        }
      }else{
        if (this.activeName =='3') {
          // 进行中的项目
          this.loadSupplierDoingProject(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='5') {
          this.loadSupplierCheckOrder(()=>{
            cb&&cb()
          })
        } else if (this.activeName =='6') {

          this.loadSupplierDeliveryOrder(()=>{
            cb&&cb()
          })
        }
      }
    },
    tabClick(val) {
      console.info(val)
      this.currentPage = 1
      // this.currentTotal = 8
      this.getList()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage=val

      // this.getList(()=>{
      //   this.currentPage=val-1
      // })
      this.getList()
    },
    // GET /loadSupplierDoingProject供应商端--进行中的项目
    loadSupplierDoingProject (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadSupplierDoingProject', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadSupplierCheckOrder供应商端--待确认的订单
    loadSupplierCheckOrder (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadSupplierCheckOrder', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // /GET /loadSupplierDeliveryOrder供应商端--待处理的发货
    loadSupplierDeliveryOrder (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadSupplierDeliveryOrder', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadSupplierItems加载供应商务数据明细信息
    loadSupplierItems (cb) {
      // DoingProjectItems 供应商进行中的项目 3
      // CheckOrderItems  供应商待确认订单   5
      // DoingDeliveryItems 供应商待发货订单  6
      // code = 0 展示

      // 不等于0  不展示
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadSupplierItems', {
        })
        .then(res => {
          this.itemLoading = false
          // console.info(res)
          if(res.data.code==0){
              // 重置tab显示
            Object.keys(this.tabShowData).map(item=>{
              this.tabShowData[item]=false
            })
            // 设置tab是否显示
            if(res.data.data.doingProjectItems.code==='0'){
              this.tabShowData['3']=true
            }
            if(res.data.data.checkOrderItems.code==='0'){
              this.tabShowData['5']=true
            }
            if(res.data.data.doingDeliveryItems.code==='0'){
              this.tabShowData['6']=true
            }
            // 设置默认选中那一项
            if(res.data.data.doingProjectItems.code==='0'){
              this.activeName = '3'
              this.setAllList(res.data.data.doingProjectItems.data,cb)
            }else if(res.data.data.checkOrderItems.code==='0'){
              this.activeName = '5'
              this.setAllList(res.data.data.checkOrderItems.data,cb)
            }else if(res.data.data.doingDeliveryItems.code==='0'){
              this.activeName = '6'
              this.setAllList(res.data.data.doingDeliveryItems.data,cb)
            }
          }else{
            this.$message.error(res.data.errorMsg)
          }


          // this.setAllList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadPurcahseItems加载采购商业务数据明细信息

    loadPurcahseItems (cb) {
      // MeApplyItems 我发起的申请 1
      // MeHandleApplyItems 待处理的申请 2
      // DoingProjectItems 供应商进行中的项目 3
      // createContractItems 我创建的合同  4

      // DoingOrderItems 采购待确认的订单 5
      // meCheckProjectItems 我审批的项目 7

      // code = 0 展示

      // 不等于0  不展示
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadPurcahseItems', {
        })
        .then(res => {
          // console.info(res)
          this.itemLoading = false
          if(res.data.code==0){
              // 重置tab显示
            Object.keys(this.tabShowData).map(item=>{
              this.tabShowData[item]=false
            })
            // 设置tab是否显示
            if(res.data.data.doingProjectItems.code==='0'){
              this.tabShowData['3']=true
            }
            if(res.data.data.doingOrderItems.code==='0'){
              this.tabShowData['5']=true
            }

            if(res.data.data.meApplyItems.code==='0'){
              this.tabShowData['1']=true
            }
            if(res.data.data.meHandleApplyItems.code==='0'){
              this.tabShowData['2']=true
            }
            if(res.data.data.createContractItems.code==='0'){
              this.tabShowData['4']=true
            }

            this.isShowMeCheckProjectItems = res.data.data.meCheckProjectItems.code
            if(res.data.data.meCheckProjectItems.code==='0'){
              this.tabShowData['7']=true
            }

            // 设置默认选中那一项
            if(res.data.data.meApplyItems.code==='0'){
              this.activeName = '1'
              this.setAllList(res.data.data.meApplyItems.data,cb)
            }else if(res.data.data.meHandleApplyItems.code==='0'){
              this.activeName = '2'
              this.setAllList(res.data.data.meHandleApplyItems.data,cb)
            }else if(res.data.data.doingProjectItems.code==='0'){
              this.activeName = '3'
              this.setAllList(res.data.data.doingProjectItems.data,cb)
            }else if(res.data.data.createContractItems.code==='0'){
              this.activeName = '4'
              this.setAllList(res.data.data.createContractItems.data,cb)
            }else if(res.data.data.doingOrderItems.code==='0'){
              this.activeName = '5'
              this.setAllList(res.data.data.doingOrderItems.data,cb)
            }else if(res.data.data.meCheckProjectItems.code==='0'){
              this.activeName = '7'
              this.setAllList(res.data.data.meCheckProjectItems.data,cb)
            }

          }else{
            this.$message.error(res.data.errorMsg)
          }

          // this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadApply采购商--我发起的申请
    loadApply (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadApply', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadHandledApply 采购商--待处理的申请
    loadHandledApply (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadHandledApply', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadDoingProject采购商--进行中的项目
    loadDoingProject (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadDoingProject', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4,
            projectType: this.projectType
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /queryContractList 采购商--我签定的合同
    queryContractList (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/queryContractList', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadDoingOrder采购商--待确认的订单
    loadDoingOrder (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadDoingOrder', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },
    // GET /loadDoingOrder采购商--我审批的项目
    loadMeCheckProject (cb) {
      this.itemLoading = true
      this.$axios
        .get('/onelink.mdata.main.api/loadMeCheckProject', {
          params: {
            pageNo: this.currentPage,
            pageSize: 4,
            projectType: this.projectType1
          }
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          this.itemLoading = false
        });
    },


  }
}
</script>
<style lang="stylus">
.workBench-itemTab{
  position: relative;
  .el-tabs__header{
    padding-right: 45px;
  }
}
.workBench-itemTab .mb0{
  margin-bottom: 0;
}
.workBench-itemTab .itemTab-more{
  height: 40px;
  line-height: 40px;
  position: absolute;
  right: 15px;
  top:15px;
  z-index: 2;
  font-size: 12px;
  color:#2E8AF1;
  border-bottom: 2px solid #e4e7ed;
  padding-left: 7px;
}
.workBench-itemTab .itemTab-more:hover{
  cursor: pointer;
}
.workBench-itemTab .fr{
  float:right
}
.workBench-itemTab .red-col{
  font-size: 12px;
  color: #EB3A3A;
  line-height: 18px;
}
.workBench-itemTab .mr15{
  margin-right: 15px;
}
.workBench-itemTab .mb15{
  margin-bottom: 15px;
}
.workBench-itemTab .mr5{
  margin-right: 5px;
}
.workBench-itemTab{
  background:#fff;
  border-radius: 5px;
  border-radius: 5px;
  padding:15px
}
.workBench-itemTab .tab-list{
  display: flex;
  flex-wrap: wrap;
}
.workBench-itemTab .tab-item{
  width: 49%;
  margin-right: 2%;
  margin-bottom: 15px;
  background: #F6F8F9;
  padding: 20px 15px;
}
.workBench-itemTab .tab-item:hover{
  cursor: pointer;
}
.workBench-itemTab .tab-item:nth-child(2n){
  margin-right: 0;
}
.workBench-itemTab .tab-item-p1{
  font-size: 14px;
  color: #303133;
  line-height: 18px;
}
.workBench-itemTab .item-p1-ellipsis{
   display: inline-block;
   width: 71%;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
 }
.workBench-itemTab .item-p7-ellipsis{
  width: 57%;
}
.workBench-itemTab .ellipsis{
  vertical-align: middle;
  display: inline-block;
  width: 71%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.workBench-itemTab .fw{

  font-weight: bold;
}
.workBench-itemTab .tab-item-p2{
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}
.workBench-itemTab .tab-item-p3{
  font-size: 12px;
  color: #303133;
  line-height: 18px;
}
.workBench-itemTab .itemTab-page {
  text-align: right;
}
.workBench-itemTab .itemTab-page .btn-prev,.workBench-itemTab .itemTab-page .btn-next{
  margin-left: 10px;
  padding-right: 10px;
  padding-left: 10px;
  color:#606266;
  font-size: 12px;
  font-weight: normal;
  line-height: 30px;
  height: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  border-radius: 4px;
}
.workBench-itemTab .itemTab-page button:hover {
    color: #2E8AF1;
}
.workBench-itemTab .itemTab-page button:disabled {
    color: #C0C4CC;
    background-color: #FFF;
    cursor: not-allowed;
}
.workBench-itemTab .el-pagination{
  padding: 0;
}

.workBench-itemTab .el-tabs__item:hover {
    color: #2E8AF1;
    cursor: pointer;
}

.workBench-itemTab .el-tabs__item.is-active {
    color: #2E8AF1;
  font-weight: bold;
}
.workBench-itemTab .el-tabs__active-bar {
    background-color: #2E8AF1;
}
  .tab-pane-project-checkout{
    .el-button{
      padding: 6px 12px;
      &.active{
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/itemTab.vue